import { Box, Card, Typography } from "@mui/material";

interface INumberInfo {
  title: string;
  value: string | number | undefined;
}

// Componente principal do painel de métricas
const NumberInfo: React.FC<INumberInfo> = ({ title, value }) => {
  return (
    <Box
      sx={{
        width: "100%",
        minWidth: 140,
      }}
    >
      <Card
        variant="outlined"
        sx={(theme) => ({
          p: 2,
          height: 80,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          position: "relative",
          backgroundColor:
            theme.palette.mode === "light" ? "#fff" : theme.palette.grey[900],
          transition: "all 0.2s ease-out",
          "&:hover": {
            borderColor: theme.palette.info.main,
          },
        })}
      >
        <Typography fontWeight="bold">{title}</Typography>
        <Typography fontSize="20px">{value}</Typography>
      </Card>
    </Box>
  );
};

export default NumberInfo;
